<template>
  <div class="setting-advanced-reply">
    <ul class="setting-advanced-tab-container module-item-style">
      <router-link
        :to="menu.path"
        tag="li"
        v-for="(menu, index) in tabbar"
        :class="$route.path == menu.path ? 'tabActived' : ''"
        :key="index"
      >{{menu.meta.title}}</router-link>
      <li class="recharge-btn" v-if="companyRoute || personalRoute">
        下载
        <a
          class="download-tpl"
          href="/Public/download/weiliao-fast-reply-template.xls"
          download
        >《快捷回复数据导入模版》</a>
        <span class="wl-btn" @click="addNewPeoblem">新建问题</span>
        <span class="wl-btn-empty" @click="importData">
          导入数据
          <input type="file" ref="importInput" hidden @change="importInputChange" />
        </span>
        <span>
          <a :href="exportUrl" class="wl-btn-empty" download>导出数据</a>
        </span>
      </li>
      <li class="recharge-btn" v-if="categoryRoute">
        <span class="wl-btn" @click="addCategory">添加分类</span>
      </li>
    </ul>
    <div class="setting-knowledge-container">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </div>

    <!--        添加-编辑分类-->
    <el-dialog
      :title="categoryDialogTitle"
      class="category-dialog"
      width="500px"
      :visible.sync="categoryVisible"
    >
      <div class="dialog-form-item">
        <div class="dialog-form-item-label">分类名称：</div>
        <el-input v-model="replyCategoryForm.content" placeholder="请输入分类名称"></el-input>
      </div>
      <div class="dialog-form-item" v-if="categoryDialogType == 'add'">
        <div class="dialog-form-item-label">话术类别：</div>
        <div>
          <el-radio v-model="replyCategoryForm.selectType" label="1">个人回复</el-radio>
          <el-radio v-model="replyCategoryForm.selectType" label="2">企业回复</el-radio>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="categoryVisible = false">取 消</el-button>
        <el-button type="primary" @click="categorySubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!--        添加-编辑问题-->
    <el-dialog
      :title="quickReplyDialogTitle"
      class="quick-reply-dialog"
      width="500px"
      @closed="closeReplyModal"
      :visible.sync="quickReplyVisible"
    >
      <div class="dialog-form-item">
        <div class="dialog-form-item-label">
          <span>*</span>分类：
        </div>
        <el-select v-model="quickReplyCategoryForm.classId" placeholder="请选择">
          <el-option
            v-for="item in categoryList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item-label">
          <span>*</span>标题：
        </div>
        <el-input v-model="quickReplyCategoryForm.title" placeholder="请输入分类名称"></el-input>
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item-label">
          <span>*</span>内容：
        </div>
        <!--                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="quickReplyCategoryForm.content"-->
        <!--                          placeholder="请输入分类名称"></el-input>-->
        <div class="el-textarea" v-if="showEditor" placeholder="请输入回答" ref="editor"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeReplyModal">取 消</el-button>
        <el-button type="primary" @click="quickReplySubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import E from "wangeditor";

export default {
  name: "setting-advanced-reply",
  data() {
    return {
      exportLoading: false,
      categoryDialogTitle: "添加分类",
      categoryDialogType: "add",
      categoryVisible: false,
      accept: "image/gif, image/jpeg, image/png, image/jpg",
      replyCategoryForm: {
        content: "",
        selectType: "1"
      },
      quickReplyDialogTitle: "添加快捷回复",
      quickReplyDialogType: "add",
      currentReplyRoute: "company",
      quickReplyVisible: false,
      categoryList: [],
      quickReplyCategoryForm: {
        title: "",
        content: "",
        classId: ""
      },
      exportUrl: "",
      showEditor: false,
      editor: null,
      answerOnlyPic: false
    };
  },
  computed: {
    tabbar() {
      let menu = [];
      let currenMenuMatched = this.$route.matched;
      this.$store.state.permission.addRoutes.map(item => {
        if (item.name == "layout") {
          item.children.map(subItem => {
            if (subItem.path == currenMenuMatched[1].path) {
              subItem.children.map(subSubItem => {
                if (subSubItem.path == currenMenuMatched[2].path) {
                  subSubItem.children.map(subSunSubItem => {
                    if (subSunSubItem.path == currenMenuMatched[3].path) {
                      menu = subSunSubItem.children;
                    }
                  });
                }
              });
            }
          });
        }
      });
      return menu;
    },
    companyRoute() {
      let route = this.$route;
      if (route.name == "settingAdvancedCompanyReply") {
        this.currentReplyRoute = "company";
        eventBus.$on("companyCategory", data => {
          this.categoryList = data;
        });
        this.exportUrl =
          process.env.VUE_APP_API_URL + "/wlapi/reply/outQrExecl?type=2";
        return true;
      } else {
        return false;
      }
    },
    personalRoute() {
      let route = this.$route;
      if (route.name == "settingAdvancedPersonalReply") {
        this.currentReplyRoute = "personal";
        eventBus.$on("personalCategory", data => {
          console.log(data);
          this.categoryList = data;
        });
        this.exportUrl =
          process.env.VUE_APP_API_URL + "/wlapi/reply/outQrExecl?type=1";
        return true;
      } else {
        return false;
      }
    },
    categoryRoute() {
      let route = this.$route;
      if (route.name == "settingAdvancedReplyCategory") {
        this.currentReplyRoute = "";
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  mounted() {
    // 分类
    eventBus.$on("editReplyCategory", data => {
      this.editCategory(data);
    });
    // 快捷回复
    eventBus.$on("editQuickReply", data => {
      this.editNewPeoblem(data);
    });
  },
  methods: {
    /**
     * 添加分类
     */
    addCategory() {
      this.categoryDialogTitle = "添加分类";
      this.categoryDialogType = "add";
      this.replyCategoryForm = {
        content: "",
        selectType: "1"
      };
      this.categoryVisible = true;
    },
    /**
     * 编辑分类
     * */
    editCategory(data) {
      this.categoryDialogTitle = "编辑分类";
      this.categoryDialogType = "edit";
      this.replyCategoryForm = {
        classId: data.id,
        content: data.groupName,
        selectType:
          typeof data.groupType == String
            ? data.groupType
            : data.groupType.toString()
      };
      this.categoryVisible = true;
    },
    /**
     *
     * 分类编辑-添加提交
     * */
    categorySubmit() {
      if (this.$utils.u_isEmpty(this.replyCategoryForm.content)) {
        this.$message({
          message: " 请输入分类名称",
          type: "error"
        });
        return false;
      }
      if (this.categoryDialogType == "add") {
        this.$http.addCategoryDataAPI(this.replyCategoryForm).then(res => {
          if (res.status == 1) {
            this.categoryVisible = false;
            eventBus.$emit("reloadCategoryTable");
            this.$message({
              message: res.msg,
              type: "success"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      } else {
        this.$http.editCategoryDataAPI(this.replyCategoryForm).then(res => {
          if (res.status == 1) {
            this.categoryVisible = false;
            eventBus.$emit("reloadCategoryTable");
            this.$message({
              message: res.msg,
              type: "success"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      }
    },
    closeReplyModal() {
      this.showEditor = false;
      this.quickReplyVisible = false;
    },
    /**
     * 初始化编辑器
     * */
    initEditor(data) {
      let editor = new E(this.$refs.editor);
      this.editor = editor;
      editor.customConfig.menus = [
        "head",
        "bold",
        "italic",
        "underline",
        "list",
        "justify",
        "image",
        "link"
      ];
      let _that = this;
      editor.customConfig.linkImgCallback = function(url) {
        _that.answerOnlyPic = true;
      };
      editor.customConfig.customUploadImg = function(files, insert) {
        let img = files[0];
        let type = img.type;
        let size = img.size;
        if (_that.accept.indexOf(type) == -1) {
          _that.$message({
            showClose: true,
            message:
              "图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg",
            type: "error",
            duration: 3 * 1000
          });
          return false;
        }
        if (size > 5242880) {
          _that.$message({
            showClose: true,
            message: "请选择5M以内的图片！",
            type: "error",
            duration: 3 * 1000
          });
          return false;
        }
        let formdata = new FormData();
        formdata.set("file", img);
        _that.$http.uploadImageAPI(formdata).then(res => {
          if (res.status == 1) {
            _that.answerOnlyPic = true;
            insert(res.data);
          }
        });
        // files 是 input 中选中的文件列表
        // insert 是获取图片 url 后，插入到编辑器的方法
      };
      editor.create();

      editor.txt.html(data);
    },
    /**
     * 添加问题
     */
    addNewPeoblem() {
      this.showEditor = true;
      this.quickReplyDialogTitle = "添加快捷回复";
      this.quickReplyDialogType = "add";
      this.quickReplyVisible = true;
      this.quickReplyCategoryForm = {
        title: "",
        content: "",
        classId: ""
      };
      this.$nextTick(() => {
        this.initEditor();
      });
    },
    /**
     * 编辑问题
     */
    editNewPeoblem(data) {
      this.showEditor = true;
      this.quickReplyDialogTitle = "编辑快捷回复";
      this.quickReplyDialogType = "edit";
      this.quickReplyVisible = true;
      this.quickReplyCategoryForm = {
        title: data.title,
        content: data.contentInitialData,
        classId: data.groupId,
        replayId: data.qrId
      };
      this.$nextTick(() => {
        // this.initEditor(data.content)
        this.initEditor(data.contentInitialData);
      });
      // this.initEditor(data)
    },
    /**
     * 快捷回复-添加、编辑数据提交
     */
    quickReplySubmit() {
      let reg = /&nbsp;/g;
      let content = this.editor.txt.text();
      this.quickReplyCategoryForm.content = this.editor.txt.html().replace(/&quot;Microsoft YaHei&quot;,/g,'');
      if (this.quickReplyCategoryForm.classId.length == 0) {
        this.$message({
          message: " 请选择分类",
          type: "error"
        });
        return false;
      }
      if (this.$utils.u_isEmpty(this.quickReplyCategoryForm.title)) {
        this.$message({
          message: " 标题不能为空",
          type: "error"
        });
        return false;
      }
      if (!this.answerOnlyPic && content.replace(reg, "").trim().length == 0) {
        this.$message({
          message: "内容不能为空",
          type: "error"
        });
        return false;
      }
      if (this.quickReplyDialogType == "add") {
        this.$http.addReplyContentAPI(this.quickReplyCategoryForm).then(res => {
          if (res.status == 1) {
            this.quickReplyVisible = false;
            if (this.currentReplyRoute == "company") {
              eventBus.$emit("reloadCompanyReply");
            } else if (this.currentReplyRoute == "personal") {
              eventBus.$emit("reloadPersonalReply");
            }
            this.$message({
              message: res.data,
              type: "success"
            });
          } else {
            this.$message({
              message: res.data,
              type: "error"
            });
          }
        });
      } else if (this.quickReplyDialogType == "edit") {
        let editData = Object.assign({}, this.quickReplyCategoryForm);
        editData.groupId = this.quickReplyCategoryForm.classId;
        delete editData.classId;
        this.$http.editReplyContentAPI(editData).then(res => {
          if (res.status == 1) {
            this.quickReplyVisible = false;
            if (this.currentReplyRoute == "company") {
              eventBus.$emit("reloadCompanyReply");
            } else if (this.currentReplyRoute == "personal") {
              eventBus.$emit("reloadPersonalReply");
            }
            this.$message({
              message: res.data,
              type: "success"
            });
          } else {
            this.$message({
              message: res.data,
              type: "error"
            });
          }
        });
      }
    },
    /**
     * 导入数据
     */
    importData() {
      this.$refs.importInput.click();
    },
    importInputChange(e) {
      let type = "";
      let file = e.target.files[0];
      let name = file.name;
      var suffix = name.substr(name.lastIndexOf("."));
      if (".xls" != suffix && ".xlsx" != suffix) {
        this.$message({
          showClose: true,
          message: "文件格式不正确，请选择Excel格式的文件导入",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      if (this.personalRoute) {
        type = "1";
      } else if (this.companyRoute) {
        type = "2";
      }
      let formdata = new FormData();
      formdata.set("file", file);
      formdata.set("type", type);
      this.$http.importReplyContentAPI(formdata).then(res => {
        if (res.status == 1) {
          if (type == 1) {
            eventBus.$emit("reloadPersonalCategoryReply");
          } else if (type == 2) {
            eventBus.$emit("reloadCompanyCategoryReply");
          }

          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.setting-advanced-reply {
  .setting-advanced-tab-container {
    display: flex;
    padding: 24px 24px 17px;
    position: relative;

    li {
      margin-right: 40px;
      color: #333333;
      font-size: 12px;
      letter-spacing: 1.4px;
      cursor: pointer;
      padding-bottom: 7px;
    }

    .recharge-btn {
      position: absolute;
      right: 20px;
      top: 50%;
      margin-top: -20px;
      margin-right: 0;

      span + span {
        margin-left: 20px;
      }
      .download-tpl {
        margin-right: 20px;
        color: $mainColor;
      }
    }
  }

  .setting-knowledge-container {
    margin-top: 15px;
  }

  .category-dialog {
    .dialog-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .dialog-form-item-label {
        width: 100px;
      }
    }
  }

  .quick-reply-dialog {
    .el-input__inner,
    .el-input,
    .el-textarea {
      width: 300px;
    }

    .el-textarea {
      li {
        list-style: inherit;
      }
    }
    .dialog-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .dialog-form-item-label {
        width: 100px;
        text-align: right;

        span {
          color: red;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
